export default "__VITE_ASSET__115263ff__"